import React, { forwardRef } from 'react';
import FormField from './FormField';

function buildSelectClassName({ error, className = '' }) {
    return ['select', error ? 'input-error' : '', className].filter(Boolean).join(' ');
}

const SelectInput = forwardRef(function SelectInput(
    {
        label,
        name,
        id,
        error,
        helper,
        note,
        required = false,
        className = '',
        fieldClassName = '',
        children,
        ...props
    },
    ref,
) {
    const selectId = id || (name ? `select-${name}` : undefined);
    const select = (
        <select
            ref={ref}
            id={selectId}
            name={name}
            required={required}
            className={buildSelectClassName({ error, className })}
            {...props}
        >
            {children}
        </select>
    );

    if (!label && !error && !helper && !note) {
        return select;
    }

    return (
        <FormField
            label={label}
            htmlFor={selectId}
            required={required}
            error={error}
            helper={helper}
            note={note}
            className={fieldClassName}
        >
            {select}
        </FormField>
    );
});

export default SelectInput;
